import React from "react";
import PropTypes from "prop-types";
import { getIn } from "formik";
import _ from "lodash";

import { cn } from "@/lib/helpers/cn";

import { TextArea } from "../../TextArea";
import { FormFieldError } from "../FormFieldError/FormFieldError";

import "../styles.scss";
import "./styles.scss";

export const FormTextArea = ({
  className,
  customError,
  formikProps,
  inputClassName,
  name,
  placeholder,
  resize,
  subTitle,
  title,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
  readOnly,
  testId,
  // a callback called each time a field changes
  // NOTE: the risk with using this is the unknown in the order
  // the formik form re-renders. If an update is made via the handleChange
  // function which triggers another form update via the onChangeCallBack,
  // logically one would think that the initial field updates could appear
  // before the onChangeCallback updates complete which would render an invalid state.
  // In practice the formik forms look to re-render very fast so this should not be a
  // problem, this is just something to watch out for
  onChangeCallBack,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    const value = event.target.value;
    await formikProps.setFieldValue(name, value);
    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
    if (onChangeCallBack) {
      await onChangeCallBack(name, value);
    }
  };

  return (
    <div className={cn("FormField-container", className)} {...{ inert: readOnly ? "" : undefined }}>
      {title && (
        <strong data-public className="FormField-title">
          {title}
        </strong>
      )}

      {subTitle && (
        <small data-public className="FormField-subTitle">
          {subTitle}
        </small>
      )}

      <TextArea
        className={cn("FormTextArea-input", inputClassName)}
        error={isTouched && errorMessage}
        ignoreEnterSubmit={true}
        name={name}
        onChange={handleChange}
        placeholder={placeholder}
        resize={resize}
        readOnly={readOnly}
        testId={testId}
        value={value}
      />

      {!customError && errorMessage && isTouched && <FormFieldError>{errorMessage}</FormFieldError>}

      {/* lets the dev pick what is displayed below the text area */}
      {customError && customError(value, errorMessage, isTouched)}
    </div>
  );
};

FormTextArea.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  customError: PropTypes.func,
  formikProps: PropTypes.object,
  testId: PropTypes.string,
};
